<template>
  <div class="autocomplete-popup__close-button-container q-d-block q-d-lg-none">
    <button
        id="autocomplete-popup__close-button"
        class="autocomplete-popup__close-button"
        type="button"
        aria-label="Wstecz"
        @click="popupStore.hideAutocomplete"
    >
      <!-- Gmail-like back arrow (24dp) -->
      <svg class="q-icon q-icon--gmail-back" viewBox="0 0 24 24" aria-hidden="true">
        <!-- chevronowa strzałka z grubą kreską i zaokrąglonymi końcami -->
        <path d="M15.5 5.5 8.5 12l7 6.5"
              fill="none" stroke="currentColor" stroke-width="2.25"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";
const popupStore = usePopupStore();
</script>

<style scoped>
/* ===== MOBILE ONLY ===== */
@media (max-width: 991.98px){
  .q-autocomplete-active .autocomplete-popup__close-button-container{
    display: grid;
    place-items: center;
  }

  .q-autocomplete-active .autocomplete-popup__close-button{
    -webkit-tap-highlight-color: transparent;
    appearance: none;
    border: 0;
    background: transparent;             /* jak w Gmailu */
    width: 44px; height: 44px;           /* duży hit-area */
    border-radius: 9999px;
    display: grid; place-items: center;
    color: #202124;                      /* Gmail neutral */
    opacity: .84;                        /* lekko zgaszona */
    cursor: pointer;
    outline: none;
  }

  .q-autocomplete-active .autocomplete-popup__close-button:hover{
    background: rgba(32,33,36,.06);
  }
  .q-autocomplete-active .autocomplete-popup__close-button:active{
    background: rgba(32,33,36,.10);
  }
  .q-autocomplete-active .autocomplete-popup__close-button:focus-visible{
    box-shadow: 0 0 0 2px rgba(32,33,36,.16);
    background: rgba(32,33,36,.06);
  }

  .q-autocomplete-active .autocomplete-popup__close-button .q-icon{
    width: 24px; height: 24px;
    display: block;
  }
}

/* Desktop – ukryty przez q-d-md-none */
</style>
